import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import { createNotification } from "../../../shared/store/notifications";

export async function deleteSocialMediaPost({ postId }) {
  const res = await axios.middleware("/aluno.asmx/Excluir_Postagem", {
    params: { postagemId: postId },
  });
  return res;
}

export const useDeleteSocialMediaPost = ({ config, postId, themeId } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => deleteSocialMediaPost({ postId }),

    onSuccess: () => {
      createNotification({
        type: "success",
        message: "Post deletado com sucesso",
      });

      queryClient.invalidateQueries(["socialMediaFeed"]);
    },
  });
};
